export const modalSizes = {
  xxs: 'xxs',
  xsm: 'xsm',
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl',
  xxl: 'xxl',
  flexible: 'flexible',
  wide: 'wide',
  fullscreen: 'fullscreen',
} as const

export type ModalSize = typeof modalSizes[keyof typeof modalSizes]

export const messageTypes = {
  neutral: 'neutral',
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
} as const

export type MessageType = typeof messageTypes[keyof typeof messageTypes]

export const footerAlign = {
  left: 'left',
  center: 'center',
  right: 'right',
  stretch: 'stretch',
} as const

export type FooterAlign = typeof footerAlign[keyof typeof footerAlign]

export const modalAlign = {
  left: 'left',
  center: 'center',
  right: 'right',
} as const

export type ModalAlign = typeof modalAlign[keyof typeof modalAlign]

export const modalVariants = {
  default: 'default',
  docked: 'docked',
}

export type ModalVariant = typeof modalVariants[keyof typeof modalVariants]
